<p-dialog header="{{ addEditChartHeader }}" [modal]="true" [(visible)]="displayAddEditChart" [style]="{ width: '50vw' }" [baseZIndex]="10000" (onHide)="closeDialog()">
    <form [formGroup]="accountForm">
        <div class="header">
            <div class="p-grid">
                <div class="p-col-12 p-lg-8 p-pb-0">
                    <h5>Account Information</h5>
                </div>
                <div class="p-col-12 p-lg-4">
                    <p-inputSwitch class="header-switch" formControlName="status"></p-inputSwitch>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="p-grid">
                <div class="p-col-6" *ngIf="addEditDialogType == dialogType.Add">
                    <label for="name">Account Category<span style="color: red">*</span></label>
                    <liono-treeSelect [filter]="true" class="border-bottom-input" [options]="accountTypes" appendTo="body" placeholder="Select Type" formControlName="parentFinancialAccountId" display="comma" [metaKeySelection]="false" selectionMode="single" (onNodeSelect)="changeChartGroup($event, accountConstants.AddAction)"></liono-treeSelect>
                </div>
                <div class="p-col-6" *ngIf="addEditDialogType == dialogType.Edit">
                    <label for="name">Account Category<span style="color: red">*</span></label>
                    <liono-treeSelect [filter]="true" class="border-bottom-input" [options]="accountTypes" appendTo="body" placeholder="Select Type" formControlName="parentFinancialAccountId" display="comma" [metaKeySelection]="false" selectionMode="single" (onNodeSelect)="changeChartGroup($event, accountConstants.AddAction)" [disabled]="addEditDialogType == dialogType.Edit"></liono-treeSelect>
                </div>
                <div class="p-col-6">
                    <label for="name">Type<span style="color: red">*</span></label>
                    <p-dropdown [options]="chartGroupsData" id="chartGroupsData" optionLabel="name" placeholder="Select Type" formControlName="subAccountTypeId" [ngModelOptions]="{ standalone: true }" (onChange)="showAddGoup()" appendTo="body"> </p-dropdown>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-6">
                    <label for="name">Number<span style="color: red">*</span></label>
                    <div class="p-inputgroup">
                        <input type="text" pInputText formControlName="displayAccountNumber" (input)="ensureDigit($event)" placeholder="{{ noRange }}" />
                    </div>
                </div>
                <div class="p-col-6">
                    <label for="name">Name<span style="color: red">*</span></label>
                    <input type="text" pInputText formControlName="name" />
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="closeDialog()" label="Cancel" class="p-button-secondary"></button>
        <button pButton [disabled]="!accountForm.valid || isDisabled" (click)="saveChart()" label="Save"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Add New Group" [modal]="true" [(visible)]="displayAddGroup" [style]="{ width: '45vw' }" (onHide)="hideAddGroup()">
    <form [formGroup]="groupForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Name</label>
                    <input type="text" pInputText style="width: 100%" name="groupName" formControlName="name" />
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button pButton (click)="hideAddGroup()" label="Cancel" class="p-button-secondary"></button>
        <button pButton label="Save" (click)="saveGroup()" [disabled]="!groupForm.valid"></button>
    </p-footer>
</p-dialog>

<p-toast position="top-right" [baseZIndex]="10000"></p-toast>
